import _ from 'lodash';
import * as React from 'react';
import { useState } from 'react';
import { useElementSize } from '../../hooks/useElementSize';
import { useLoc } from '../../hooks/useLoc';
import firstCapitalCase from '../../services/firstCapitalCase';
import { WeatherData } from '../../templates/fragments/weather-data';
import { ShowMoreAccordion } from '../shared/base/show-more-accordion';
import { Chart } from './chart/chart';
import { chartWidthBreakpoints } from './chart/service';
export const ChartWrapper = ({ weatherData }: { weatherData: WeatherData }) => {
    const loc = useLoc();
    const windowWidth = useElementSize({});
    const isBig = !windowWidth || (windowWidth >= chartWidthBreakpoints.globalWindowBreakpoint);
    const isSmall = !windowWidth || (windowWidth < chartWidthBreakpoints.globalWindowBreakpoint);
    const [moreCharts, setMoreCharts] = useState(false);
    return (<div>
        {isBig && <Chart
            weatherData={weatherData}
            className="mdmax:hidden"
        />}
        {isSmall && <><Chart
            weatherData={weatherData}
            fixedMeasures={['tmax', 'tmin', 'sst', 'ppt']}
            title={loc('common.weatherOverview')}
            className="md:hidden"
        />
            <ShowMoreAccordion
                onClick={(isOpen) => {
                    setMoreCharts(isOpen);
                }}
                label={`Show less charts`}
                labelClosed={`Show more charts`}
                initialOpen={false}
            />
            {moreCharts && <Chart
                weatherData={weatherData}
                fixedMeasures={['wet']}
                title={`${firstCapitalCase(loc('common.measures.wet'))} ${loc('common.chart')}`}
                className="md:hidden"
            />}
            {moreCharts && _.some(weatherData.sunhrs, v => v != 0) && <Chart
                weatherData={weatherData}
                fixedMeasures={['sunhrs']}
                title={`${firstCapitalCase(loc('common.measures.sunhrs'))} ${loc('common.chart')}`}
                className="md:hidden"
            />}
            {moreCharts && _.some(weatherData.ws, v => v != 0) && <Chart
                weatherData={weatherData}
                fixedMeasures={['ws']}
                title={`${firstCapitalCase(loc('common.measures.ws'))} ${loc('common.chart')}`}
                className="md:hidden"
            />}
            {moreCharts && _.some(weatherData.rhm, v => v != 0) && <Chart
                weatherData={weatherData}
                fixedMeasures={['rhm']}
                title={`${firstCapitalCase(loc('common.measures.rhm'))} ${loc('common.chart')}`}
                className="md:hidden"
            />}</>}

    </div>)
}